// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8d4df","twoButtons":"styles_twoButtons__IDfAS"};